import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "collections__item" }
const _hoisted_2 = {
  key: 1,
  crossorigin: "anonymous",
  class: "collections__img",
  alt: ""
}
const _hoisted_3 = { class: "collections__text-box" }
const _hoisted_4 = { class: "collections__name card__title" }
const _hoisted_5 = { class: "collections__count" }

import {
  CollectionListItem,
  CustomList,
  PublicInterface,
} from '@/models/interfaces'
import { CollectionsView } from '@/models/docs.list.collection'
import DynamicCover from './DynamicCover.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectionCard',
  props: {
    doc: {},
    view: {},
    coverImages: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: __props.view.startLinkParams(__props.doc),
      class: "collections__link"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["collections__img-box", 
          __props.coverImages
            ? 'collections__img-box--dynamic'
            : 'collections__img-box--static'
        ])
        }, [
          (__props.coverImages)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (n) => {
                return _createVNode(DynamicCover, {
                  key: n,
                  index: n,
                  image: __props.coverImages[n - 1],
                  class: "collections__dynamic-img"
                }, null, 8, ["index", "image"])
              }), 64))
            : _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_2, null, 512)), [
                [_directive_lazy, { src: __props.doc.cover_image }]
              ])
        ], 2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(__props.doc.title), 1),
          _createElementVNode("h4", _hoisted_5, _toDisplayString(__props.doc.doc_count) + " books", 1),
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _: 3
    }, 8, ["to"])
  ]))
}
}

})